/**
 * Whether the EduFadder extension is installed in this browser, and which
 * version — read from two data attributes the extension's tiny "site bridge"
 * script sets on <html> (it runs only on this site and reads nothing).
 */
import { useEffect, useState } from "react";

export interface ExtensionStatus {
  installed: boolean;
  version: string | null;
  autoDetect: "on" | "off" | null;
}

function read(): ExtensionStatus {
  const ds = document.documentElement.dataset;
  const version = ds.edufadderExtension ?? null;
  const auto = ds.edufadderAutoDetect;
  return { installed: version !== null, version, autoDetect: auto === "on" || auto === "off" ? auto : null };
}

export function useExtensionStatus(): ExtensionStatus {
  const [status, setStatus] = useState<ExtensionStatus>(read);
  useEffect(() => {
    const observer = new MutationObserver(() => setStatus(read()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-edufadder-extension", "data-edufadder-auto-detect"] });
    setStatus(read());
    return () => observer.disconnect();
  }, []);
  return status;
}

export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map((p) => parseInt(p, 10) || 0);
  const pb = b.split(".").map((p) => parseInt(p, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d < 0 ? -1 : 1;
  }
  return 0;
}
